import React, { PureComponent } from 'react';
import Button from '@rezdy/components/Button';
import { H4 } from '@rezdy/components/Heading';
import Layout from './Layout';
import TextStyle from '@rezdy/components/TextStyle';
import routes from '../constants/routes';
import routing from '../services/routing';
import { WithTranslation, withTranslation } from 'react-i18next';

export interface IUserProfileProps extends WithTranslation {
    context: string;
}

class UserProfile extends PureComponent<IUserProfileProps> {
    onSecondaryClick = () => {
        routing.redirectUri();
    };

    onClickChangeEmail = () => {
        routing.push(routes.CHANGE_EMAIL);
    };

    onClickChangeProfile = () => {
        routing.push(routes.USER_DETAILS);
    };

    onClickChangePassword = () => {
        routing.push(routes.CHANGE_PASSWORD);
    };

    onClickSetupMfa = () => {
        routing.push(routes.SETUP_MFA);
    };

    onClick = () => {
        routing.push(routes.SIGN_IN);
    };

    renderSecondaryAction = () => {
        const { context, i18n } = this.props;
        return (
            <Button action="secondary" onClick={this.onSecondaryClick} reversed>
                {i18n.t('secondaryAction', { context })}
            </Button>
        );
    };

    render() {
        const { i18n } = this.props;
        return (
            <Layout secondaryAction={this.renderSecondaryAction()}>
                <TextStyle align="center">
                    <H4>{i18n.t('USER_PROFILE')}</H4>
                </TextStyle>
                {/* <Button
                    action="secondary"
                    width="100%"
                    onClick={this.onClickSetupMfa}
                >
                    {i18n.t("SETUP_MFA")}
                </Button> */}
                <Button action="secondary" width="100%" onClick={this.onClickChangeProfile}>
                    {i18n.t('CHANGE_DETAILS')}
                </Button>
                <Button action="secondary" width="100%" onClick={this.onClickChangePassword}>
                    {i18n.t('CHANGE_PASSWORD')}
                </Button>
                <Button action="secondary" width="100%" onClick={this.onClickChangeEmail}>
                    {i18n.t('CHANGE_EMAIL')}
                </Button>
            </Layout>
        );
    }
}

export default withTranslation()(UserProfile);
